
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class JewelleryTagSheetGrid extends Serenity.EntityGrid<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.JewelleryTagSheet'; }
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.JewelleryTagSheetService.baseUrl; }

        public vouchernos: string[];
        public productcodes: string[];
        public partyids: number[];
        public vouchertypeid: number;

        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);

            for (let col of columns) {
                //console.log(col);
                if (col.field == "ProductCode" || col.field == "Weight" || col.field == "NetWeight" || col.field == "KaratName" ) col.groupName = "Details";

                if (col.field == "DiamondPieces" || col.field == "DiamondWeight") col.groupName = "Diamond";
                if (col.field == "RoundSize" || col.field == "RoundPieces" || col.field == "RoundWeight") col.groupName = "Round";
                if (col.field == "FancySize" || col.field == "FancyPieces" || col.field == "FancyWeight" ) col.groupName = "Fancy";
                if (col.field == "Fancy2Size" || col.field == "Fancy2Pieces" || col.field == "Fancy2Weight") col.groupName = "Fancy 2"; 
                if (col.field == "PreciousPieces" || col.field == "PreciousWeight") col.groupName = "Precious";
                if (col.field == "SemiPreciousPieces" || col.field == "SemiPreciousWeight") col.groupName = "Semi Precious";
                if (col.field == "MFAmount") col.groupName = "MF";
            }

            plugin.enableColumnGrouping();

            grid.setColumns(columns);
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

           
            return grid;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Stock/StockJewellery/List',
                    idField: "ProductCode",
                    textField: "ProductCode",
                    multiple: true

                },
                field: 'ProductCode',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push((values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductCodes = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).ProductCodes = temp;
                    }
                    this.productcodes = temp;
                },

                cssClass: 'hidden-xs'
            });

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'CategoryLkp',
                    multiple: true

                },
                field: 'CategoryId',
                title: 'Category',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CategoryIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).CategoryIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'SubCategoryLookup',
                    multiple: true

                },
                field: 'SubCategoryIds',
                title: 'Sub Category',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).SubCategoryIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).SubCategoryIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            return filters;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            var self = this;
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons = buttons.filter(x => x.cssClass != "column-picker-button");
            
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Stock.JewelleryTagSheetService.baseUrl + '/ExportExcel',
                        request: {
                            VoucherTypeId: self.vouchertypeid,
                            VoucherNos: self.vouchernos,
                            PartyIds: self.partyids,
                            ProductCodes: self.productcodes,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds
                        },

                        target: '_blank'
                    });
                }
            });
            //buttons.push({
            //    title: 'Print With Images',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        var items = this.view.getItems();
            //        if (items.length == 0) {
            //            q.alert("Warning", "No data to export", true, 2999);
            //            return;
            //        }

            //        // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        Q.postToService({
            //            service: TabAurous.Stock.JewelleryShapeandVoucherService.baseUrl + '/ExportExcelWithImages',
            //            request: {
            //                VoucherTypeId: self.vouchertypeid,
            //                VoucherNos: self.vouchernos,
            //                PartyIds: self.partyids,
            //            },


            //            target: '_blank'
            //        });
            //    }
            //});
            //buttons.push(Common.ExcelExportHelper.createToolButton({
            //    grid: this,
            //    service: TabAurous.Stock.JewelleryShapeWiseService.baseUrl + '/ListExcel',
            //    onViewSubmit: () => this.onViewSubmit(),
            //    separator: true
            //}));
            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    onViewSubmit: () => this.onViewSubmit()
            //}));

            return buttons;
        }
    }
}